<div
  class="sidebar z-40 bg-[#FCFCFD] dark:bg-[#0C0C1A] transition-[width] duration-300 flex flex-col relative border-r border-[#EDEAF0] dark:border-[#303049]"
  [class.expanded]="isExpanded"
>
  <ul class="flex-1">
    <!-- LOGO -->
    <li class="mt-6 mb-4">
      <div
        class="flex items-center w-full"
        [ngClass]="
          isExpanded ? 'px-4 justify-start gap-3' : 'px-2 justify-center gap-2'
        "
      >
        <!-- BOTÃO: controle da sidebar -->
        <button
          type="button"
          class="flex items-center justify-center rounded-lg hover:bg-[#F4F7FB] dark:hover:bg-[#303049] transition-colors shrink-0"
          [ngClass]="isExpanded ? 'w-10 h-10' : 'w-9 h-9'"
          (click)="onToggleSidebarClick($event)"
          aria-label="Alternar sidebar"
          title="Alternar sidebar"
        >
          <!-- ÍCONE HAMBURGER -->
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-menu-icon lucide-menu transition-all duration-300 text-[#0C0C1A] dark:text-[#FCFCFD]"
            [ngClass]="isExpanded ? 'w-6 h-6' : 'w-5 h-5'"
          >
            <path d="M4 5h16"></path>
            <path d="M4 12h16"></path>
            <path d="M4 19h16"></path>
          </svg>
        </button>

        <!-- LOGO -->
        <a
          routerLink="/modulos"
          class="flex items-center shrink-0"
          aria-label="Ir para módulos"
        >
          @if (isExpanded) {
            <img
              src="images/logoCanviAzul.png"
              class="h-7 w-auto block dark:hidden"
              alt="Logo Canvi"
            />
            <img
              src="images/logoCanviDark.png"
              class="h-7 w-auto hidden dark:block"
              alt="Logo Canvi"
            />
          } @else {
            <img
              src="icons/icons-sidebar/iconCanvi.png"
              class="h-7 w-7 block dark:hidden"
              alt="Logo Light"
            />
            <img
              src="icons/icons-sidebar/iconCanviDark.png"
              class="h-7 w-7 hidden dark:block"
              alt="Logo Dark"
            />
          }
        </a>
      </div>
    </li>

    <!-- ITENS DO MENU (padrão) -->
    <div class="mt-10 px-3">
      <li
        *ngFor="let item of menuItems; let i = index"
        [class.active]="itemAtivoIndex === i"
        class="group"
      >
        <div
          class="menu-item-container flex items-center w-full"
          (click)="setActive(i); $event.preventDefault()"
        >
          <a
            href="#"
            class="menu-item flex items-center w-full rounded-xl px-4 py-3 transition-colors hover:bg-[#F4F7FB] dark:hover:bg-[#303049] text-[#0C0C1A] dark:text-[#EDEAF0]"
          >
            <!-- ÍCONE DO MÓDULO -->
            <lucide-icon
              [name]="resolverIconeMenuItem(item)"
              [size]="20"
              [strokeWidth]="1.5"
              class="menu-icon shrink-0 text-[#0C0C1A] dark:text-[#EDEAF0]"
              [attr.aria-label]="item.titulo"
            ></lucide-icon>

            <!-- MÓDULO: 14px/400 normal | selecionado = 14px/600 -->
            <span
              class="titulo font-canvi text-subtitle flex-1"
              [ngClass]="{ 'font-semibold': itemAtivoIndex === i }"
            >
              {{ item.titulo }}
            </span>

            @if (item.subItems && isExpanded) {
              <svg
                class="w-5 h-5 ml-auto transition-transform duration-200 text-[#0C0C1A] dark:text-[#EDEAF0]"
                [class.rotate-180]="submenusAbertos[i]"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.2"
              >
                <path d="M19 9l-7 7-7-7" />
              </svg>
            }
          </a>
        </div>

        <!-- SUBMENU padrão -->
        @if (isExpanded && submenusAbertos[i]) {
          <div class="submenu">
            <ul>
              <li
                *ngFor="let sub of item.subItems; let j = index"
                (click)="selecionarSubOpcao(i, j); $event.stopPropagation()"
                [class.active-sub]="
                  itemAtivoIndex === i && indiceSubmenuAtivo === j
                "
                class="py-1 cursor-pointer transition-colors font-sm text-subtitle"
                [ngClass]="{
                  'font-semibold':
                    itemAtivoIndex === i && indiceSubmenuAtivo === j,
                }"
              >
                <img
                  src="icons/icons-navbar-submenu/iconSeta.png"
                  alt="Submenu Icon"
                  class="submenu-icon inline-block mr-2 dark:filter dark:brightness-0 dark:invert"
                />
                <span class="submenu-titulo">
                  {{ sub.titulo.charAt(0).toUpperCase() + sub.titulo.slice(1) }}
                </span>
              </li>
            </ul>
          </div>
        }
      </li>
    </div>

    <!-- ========== SEÇÃO: FIXADOS ========== -->
    @if (isExpanded && itensFixados.length) {
      <li class="px-4 mt-4">
        <div
          class="text-xs uppercase tracking-wide text-[#6b7280] dark:text-[#a1a1b5] mb-2"
        >
          Fixados
        </div>
        <hr class="border-[#EDEAF0] dark:border-[#303049] mb-2" />
      </li>

      <li class="mt-1">
        <ul>
          <li *ngFor="let fx of itensFixados" class="group">
            <div
              class="menu-item-container flex items-center w-full"
              (click)="
                alternarSubmenuFixado(fx.moduloCompleto);
                $event.preventDefault()
              "
              A
            >
              <a
                href="#"
                class="menu-item flex items-center w-full rounded-xl px-4 py-3 transition-colors hover:bg-[#F4F7FB] dark:hover:bg-[#303049] text-[#0C0C1A] dark:text-[#EDEAF0]"
              >
                <!-- ÍCONE DO FIXADO (igual ao menu normal) -->
                <lucide-icon
                  [name]="resolverIconeMenuItem(fx)"
                  [size]="20"
                  [strokeWidth]="1.5"
                  class="menu-icon shrink-0 text-[#0C0C1A] dark:text-[#EDEAF0]"
                  [attr.aria-label]="fx.titulo"
                ></lucide-icon>

                <span class="titulo font-canvi text-subtitle flex-1">
                  {{ fx.titulo }}
                </span>

                <!-- PIN -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-pin-icon lucide-pin w-4 h-4 mr-2 opacity-70 hover:opacity-100 cursor-pointer text-[#0C0C1A] dark:text-[#EDEAF0]"
                  title="Desafixar"
                  (click)="
                    alternarFixacaoSidebar(fx.moduloCompleto);
                    $event.stopPropagation()
                  "
                >
                  <path d="M12 17v5"></path>
                  <path
                    d="M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z"
                  ></path>
                </svg>

                <!-- SETA -->
                <svg
                  class="w-5 h-5 ml-auto transition-transform duration-200 text-[#0C0C1A] dark:text-[#EDEAF0]"
                  [class.rotate-180]="
                    fixadosAbertos[obterIdModulo(fx.moduloCompleto)]
                  "
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.2"
                >
                  <path d="M19 9l-7 7-7-7" />
                </svg>
              </a>
            </div>

            @if (
              isExpanded && fixadosAbertos[obterIdModulo(fx.moduloCompleto)]
            ) {
              <div class="submenu">
                <ul>
                  <li
                    *ngFor="let sub of fx.subItems; let k = index"
                    class="py-1 cursor-pointer transition-colors font-sm text-subtitle"
                    (click)="
                      selecionarSubOpcaoFixado(fx, k); $event.stopPropagation()
                    "
                    [ngClass]="{
                      'font-semibold': tituloSubmenuAtivo === sub.titulo,
                    }"
                  >
                    <img
                      src="icons/icons-navbar-submenu/iconSeta.png"
                      alt="Submenu Icon"
                      class="submenu-icon inline-block mr-2 dark:filter dark:brightness-0 dark:invert"
                    />
                    <span class="submenu-titulo">
                      {{
                        sub.titulo.charAt(0).toUpperCase() + sub.titulo.slice(1)
                      }}
                    </span>
                  </li>
                </ul>
              </div>
            }
          </li>
        </ul>
      </li>
    }
  </ul>

  <!-- LOGOUT -->
  <!-- <div
    class="logout-container border-t border-[#EDEAF0] dark:border-[#303049] absolute bottom-0 w-full"
  >
    <li
      class="logout group cursor-pointer"
      [class.active]="itemAtivoIndex === -1"
      (click)="logout()"
    >
      <a
        href="#"
        class="menu-item flex items-center w-full p-4"
        (click)="$event.preventDefault()"
      >
        <img
          src="/icons/icons-sidebar/iconSair-light.png"
          class="menu-icon block dark:hidden"
          alt="Sair"
        />
        <img
          src="/icons/icons-sidebar/iconSair-dark.png"
          class="menu-icon hidden dark:block"
          alt="Sair"
        />
        <span
          class="font-canvi font-semibold text-[16px] leading-[19.2px] text-[#0C0C1A] dark:text-white"
          >Sair</span
        >
      </a>
    </li>
  </div> -->
</div>
